import { render, staticRenderFns } from "./shelter-areas-archived.vue?vue&type=template&id=4c4c34d6&scoped=true"
import script from "./shelter-areas-archived.vue?vue&type=script&lang=js"
export * from "./shelter-areas-archived.vue?vue&type=script&lang=js"
import style0 from "./shelter-areas-archived.vue?vue&type=style&index=0&id=4c4c34d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4c34d6",
  null
  
)

export default component.exports